/* Before and after players, on Web Audio.

   WHY WEB AUDIO. Version one ran two <audio> elements with one muted, and
   nudged the inactive one's currentTime whenever the pair drifted. That nudge
   WAS the bug: setting currentTime on a playing element forces a re-buffer, and
   two elements on independent clocks cross any tight threshold constantly, so
   the silent track sat in a permanent seek-and-rebuffer loop. Unmute it and you
   got seconds of nothing while the bar kept moving.

   Here both files are decoded into memory and started from ONE AudioContext
   clock at the same instant, so they cannot drift and there is nothing to
   correct. Switching is a gain change on audio already running: no seek, no
   buffering, nothing that can stall. The 12 ms ramp only stops a click between
   two different waveforms.

   COST: a row downloads and decodes both files before it can start, so the
   first press shows a loading state. One honest wait beats a dropout on every
   switch, and switching is the point of the section.

   SCRUBBING. Pressing anywhere on the bar plays from there, and you can drag
   along it. During a drag only the FILL is repainted and the seek is committed
   once on release, because every commit rebuilds both buffer sources and doing
   that per pointermove would stutter. paint() therefore skips its own repaint
   while scrubbing, or the two would fight over the same style. */
(function(){
  var AC = window.AudioContext || window.webkitAudioContext;
  var rows = [].slice.call(document.querySelectorAll('.ev-abplay'));
  if (!rows.length || !AC) return;

  var ctx = null;
  function audio(){ if (!ctx) ctx = new AC(); return ctx; }

  var players = [];
  function stopOthers(me){ players.forEach(function(p){ if (p !== me) p.stop(); }); }

  rows.forEach(function(el){
    var dryUrl = el.getAttribute('data-dry');
    var wetUrl = el.getAttribute('data-wet');
    if (!dryUrl || !wetUrl) return;

    var btn  = el.querySelector('.ev-abbtn');
    var fill = el.querySelector('.ev-abfill');
    var bar  = el.querySelector('.ev-abbar');
    var togs = [].slice.call(el.querySelectorAll('.ev-abt'));

    var buf = { dry: null, wet: null };
    var src = { dry: null, wet: null };
    var gain = { dry: null, wet: null };
    var side = 'wet', playing = false, loading = false, scrub = false;
    var startedAt = 0, offset = 0, dur = 0, raf = 0;

    function load(){
      if (buf.dry && buf.wet) return Promise.resolve();
      if (loading) return loading;
      el.classList.add('is-loading');
      var c = audio();
      loading = Promise.all([dryUrl, wetUrl].map(function(u){
        return fetch(u).then(function(r){ return r.arrayBuffer(); })
          .then(function(ab){
            return new Promise(function(res, rej){ c.decodeAudioData(ab, res, rej); });
          });
      })).then(function(bufs){
        buf.dry = bufs[0]; buf.wet = bufs[1];
        dur = Math.min(buf.dry.duration, buf.wet.duration);
        el.classList.remove('is-loading'); loading = false;
      }).catch(function(){
        el.classList.remove('is-loading'); el.classList.add('is-failed'); loading = false;
        throw new Error('load failed');
      });
      return loading;
    }

    function paint(){
      if (!playing) return;
      if (!scrub) {
        var pos = (audio().currentTime - startedAt + offset) % dur;
        fill.style.width = ((pos / dur) * 100).toFixed(2) + '%';
      }
      raf = requestAnimationFrame(paint);
    }

    function begin(at){
      var c = audio();
      ['dry','wet'].forEach(function(k){
        var g = c.createGain();
        g.gain.value = (k === side) ? 1 : 0;
        g.connect(c.destination);
        var s = c.createBufferSource();
        s.buffer = buf[k]; s.loop = true; s.connect(g);
        gain[k] = g; src[k] = s;
      });
      var t0 = c.currentTime + 0.02;   // ONE start time for both: no drift possible
      src.dry.start(t0, at % dur);
      src.wet.start(t0, at % dur);
      startedAt = t0; offset = at % dur;
      playing = true;
      el.classList.add('is-playing');
      cancelAnimationFrame(raf); raf = requestAnimationFrame(paint);
    }

    function halt(){
      if (!playing) return;
      var c = audio();
      offset = (c.currentTime - startedAt + offset) % dur;
      ['dry','wet'].forEach(function(k){
        if (src[k]) { try { src[k].stop(); } catch(e){} src[k].disconnect(); src[k] = null; }
        if (gain[k]) { gain[k].disconnect(); gain[k] = null; }
      });
      playing = false;
      el.classList.remove('is-playing');
      cancelAnimationFrame(raf); raf = 0;
    }

    var api = { stop: halt };
    players.push(api);

    function setSide(next){
      side = next;
      togs.forEach(function(o){ o.classList.toggle('is-on', o.getAttribute('data-side') === side); });
      if (!playing) return;
      var c = audio(), t = c.currentTime, R = 0.012;
      ['dry','wet'].forEach(function(k){
        if (!gain[k]) return;
        var g = gain[k].gain;
        g.cancelScheduledValues(t);
        g.setValueAtTime(g.value, t);
        g.linearRampToValueAtTime(k === side ? 1 : 0, t + R);
      });
    }

    btn.addEventListener('click', function(){
      var c = audio();
      if (c.state === 'suspended') c.resume();
      if (playing) { halt(); return; }
      load().then(function(){ stopOthers(api); begin(offset); }).catch(function(){});
    });

    togs.forEach(function(t){
      t.addEventListener('click', function(){ setSide(t.getAttribute('data-side')); });
    });

    // ---- scrub ----------------------------------------------------------
    function pctFrom(e){
      var r = bar.getBoundingClientRect();
      return Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    }
    function show(p){ fill.style.width = (p * 100).toFixed(2) + '%'; }

    bar.addEventListener('pointerdown', function(e){
      var c = audio();
      if (c.state === 'suspended') c.resume();
      scrub = true;
      el.classList.add('is-scrub');
      try { bar.setPointerCapture(e.pointerId); } catch(err){}
      show(pctFrom(e));
      e.preventDefault();
    });

    bar.addEventListener('pointermove', function(e){
      if (scrub) show(pctFrom(e));
    });

    function release(e){
      if (!scrub) return;
      scrub = false;
      el.classList.remove('is-scrub');
      var p = pctFrom(e);
      show(p);
      // Pressing the bar always plays from that point, whether or not it was
      // already running. That is the whole ask: click anywhere, hear there.
      load().then(function(){
        var to = p * dur;
        if (playing) { halt(); begin(to); }
        else { stopOthers(api); begin(to); }
      }).catch(function(){});
    }
    bar.addEventListener('pointerup', release);
    bar.addEventListener('pointercancel', release);
  });

  document.addEventListener('visibilitychange', function(){
    if (document.hidden) players.forEach(function(p){ p.stop(); });
  });
})();
